import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { Field } from "formik";
import { Label } from "../atoms/Label";
import { FieldError, LockIcon } from "../atoms";
import { FlexRowCenter } from "../../box";
import { Column, Input, YearInput, MainLabel, SeparateFieldError, } from "./styles";
import { useHandleSeparateFields } from "./useHandleSeparateFields";
import { toggleErrorColor, validateRange } from "./helpers";
/**
 * A formik field for date input with separate month, day, and year fields.
 *
 * @param {DateFieldProps} props The props for the component.
 * @returns {JSX.Element} The rendered date field input component.
 */
export const DateFieldInput = ({ label, name, disabled, range, }) => {
    const { onBlurDay, onBlurMonth, onBlurYear, onChangeDay, onChangeMonth, onChangeYear, onPasteDate, yearRef, monthRef, dayRef, error, } = useHandleSeparateFields(name, disabled, range);
    const [rangeErr, setRangeErr] = useState("");
    return (_jsx(Field, { name: name, validate: (value) => {
            const { isAfter, isBefore } = validateRange(new Date(value), range);
            const colorFields = (color) => {
                toggleErrorColor(monthRef, color);
                toggleErrorColor(dayRef, color);
                toggleErrorColor(yearRef, color);
            };
            if (range) {
                if (isAfter) {
                    setRangeErr("Date is in future");
                    colorFields("red");
                }
                else if (isBefore) {
                    setRangeErr("Date is in past");
                    colorFields("red");
                }
                else if (rangeErr) {
                    setRangeErr("");
                    colorFields("white");
                }
            }
        }, children: () => {
            return (_jsxs(_Fragment, { children: [_jsxs(Label, { children: [_jsx(MainLabel, { visible: true, "data-test-id": `label-${name}`, children: label }), _jsxs(FlexRowCenter, { children: [_jsxs(Column, { children: [_jsx(Label, { children: "Month" }), _jsx(Input, { label: "Month", testId: `month-${name}`, type: "tel", ref: monthRef, maxLength: 2, placeholder: "MM", onChange: onChangeMonth, onBlur: onBlurMonth, onPaste: onPasteDate, disabled: disabled })] }), _jsxs(Column, { children: [_jsx(Label, { children: "Day" }), _jsx(Input, { label: "Day", testId: `day-${name}`, type: "tel", ref: dayRef, maxLength: 2, placeholder: "DD", onChange: onChangeDay, onBlur: onBlurDay, onPaste: onPasteDate, disabled: disabled })] }), _jsxs(Column, { children: [_jsx(Label, { children: "Year" }), _jsx(YearInput, { label: "Year", testId: `year-${name}`, type: "tel", ref: yearRef, minLength: 4, maxLength: 4, placeholder: "YYYY", onChange: onChangeYear, onPaste: onPasteDate, onBlur: onBlurYear, disabled: disabled })] }), disabled && (_jsx("div", { style: { marginLeft: "auto" }, children: _jsx(LockIcon, {}) }))] })] }), (error || rangeErr) && !disabled && (_jsx(SeparateFieldError, { "data-test-id": "separate-field-error", children: error || rangeErr })), _jsx(FieldError, { name: name })] }));
        } }));
};
